export const callCenter = '(+62)215701505';

export default {
  callCenter,
};
